import { render, staticRenderFns } from "./RulesSevenWonders.vue?vue&type=template&id=31d3e22e"
import script from "./RulesSevenWonders.vue?vue&type=script&lang=ts"
export * from "./RulesSevenWonders.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports